import React from 'react';
import { Stack } from 'react-bootstrap';

import Button from 'components/DesignSystem/Button';

interface ActionsProps {
  onSavePreference: () => void;
  onRealizarConsulta: () => void;
  onLimparFiltros: () => void;
  filtrosCompletos: boolean;
}

export default function Actions({
  onSavePreference,
  onRealizarConsulta,
  onLimparFiltros,
  filtrosCompletos,
}: ActionsProps) {
  return (
    <Stack className="pt-4" gap={2}>
      <Button className="w-100" onClick={onRealizarConsulta} disabled={!filtrosCompletos}>
        Realizar Consulta
      </Button>
      <Button className="w-100" onClick={onSavePreference}>
        Salvar nova preferência
      </Button>
      <Button type="secondary" className="w-100" onClick={onLimparFiltros}>
        Limpar filtros
      </Button>
    </Stack>
  );
}
